import { enqueueSnackbar } from 'notistack';

export function withMutationNotifications({ success, error }: { success: () => string; error: () => string }) {
  return async (_arg: unknown, { queryFulfilled }: { queryFulfilled: Promise<unknown> }) => {
    try {
      await queryFulfilled;
      enqueueSnackbar(success(), { variant: 'success' });
    } catch (err: any) {
      enqueueSnackbar(error(), { variant: 'collapsible', error: err?.error });
    }
  };
}
